
import { Component, Vue, Prop } from 'vue-property-decorator'
import lsPagination from '@/components/ls-pagination.vue'
import { RequestPaging } from '@/utils/util'
import { apiScoreList, apiScoreAudit, apiScoreGrant, apiScoreRecycle, apiScoreShops } from '@/api/score'
import LsDialog from '@/components/ls-dialog.vue'
@Component({
    components: {
        lsPagination,
        LsDialog
    }
})
export default class AiList extends Vue {
    $refs!: { dialog: any; dialog3: any }
    tableData: Array<object> = []
    AuditTime: Array<object> = []
    pager = new RequestPaging()
    scoreappleVisible: Boolean = false //查看
    scoreGrant: Boolean = false //发放
    params: any = {
        id: '',
        status: 2
    }
    depositData: any = {
        s_id: '',
        type: 1,
        score: ''
    }
    scoreReject: Boolean = false // 驳回
    Rejects: any = {
        id: '',
        status: 3
    }
    search: any = {
        shop_name: '' //公司名称
    }
    viewListApply: any = {}
    url: any = ''
    handleCurrentChange(val: any) {
        this.viewListApply = val
        this.url = val.voucher
        this.params.id = val.id
        this.Rejects.id = val.id
    }
    // 拆分时间
    splitStartTime() {
        if (this.tableData != null) {
            this.search.start_time = this.tableData[0]
            this.search.end_time = this.tableData[1]
        }
    }
    splitAuditTime() {
        if (this.AuditTime != null) {
            this.search.start_audit_time = this.AuditTime[0]
            this.search.end_audit_time = this.AuditTime[1]
        }
    }
    //商城列表
    searchview() {
        this.pager
            .request({
                callback: apiScoreShops,
                params: {
                    ...this.search
                }
            })
            .then(res => {})
    }

    sendEarnest() {
        if (this.depositData.deposit === '') {
            this.$message({
                message: '请输入大于0的数字',
                type: 'error'
            })
            return
        }
        if (this.depositData.type === 1) {
            apiScoreGrant(this.depositData).then(res => {
                this.$message({
                    message: '发放成功',
                    type: 'success'
                })
                this.searchview()
                this.$refs.dialog.close()
            })
        } else {
            apiScoreRecycle(this.depositData).then(res => {
                this.$message({
                    message: '回收成功',
                    type: 'success'
                })
                this.searchview()
                this.$refs.dialog.close()
            })
        }
    }

    handleInput(value: any) {
        if (!Number.isInteger(Number(value)) || value <= 0) {
            this.$message({
                message: '请输入大于0的数字',
                type: 'warning'
            })
            this.depositData.deposit = ''
        }
    }
    close() {
        this.depositData = {
            s_d: '',
            type: 1,
            score: ''
        }
    }
    //驳回申请
    scoreviewRejects() {
        this.scoreReject = false
        apiScoreAudit(this.Rejects)
            .then((res: any) => {
                this.$alert('您已成功驳回本次申请', '驳回成功', {
                    confirmButtonText: '确定',
                    //   center: true,
                    callback: action => {
                        this.$message({
                            type: 'success',
                            message: `驳回成功`
                        })
                    }
                })
                this.searchview()
            })
            .catch(err => {})
    }
    searchSelect(value: any) {
        this.search.status = value
    }
    //重置表单
    reset() {
        Object.keys(this.search).map(key => {
            this.$set(this.search, key, '')
        })
        this.searchview()
    }
    created() {
        this.searchview()
    }
}
